export const settings = {
	workingPeriod: {
		deletedPeriod: "Période supprimée.",
		addDaysAndTime: "Ajouter des jours et horaires",
		addOpeningHours: "Ajouter des heures d'ouverture",
		daysOfTheWeek: "Jours de la semaine",
		start: "Début",
		end: "Fin",
		errors: {
			startTimeRequired: "L'heure de début est obligatoire",
			startTimeMinLength: "L'heure de début doit contenir au moins 5 caractères",
			endTimeRequired: "L'heure de fin est obligatoire",
			endTimeMinLength: "L'heure de fin doit contenir au moins 5 caractères",
			daysRequired: "Sélectionnez au moins 1 jour",
			endTimeAfterStart: "L'heure de fin doit être supérieure à l'heure de début",
		},
	},
	menu: {
		productsWeb: {
			title: "Produits Web",
			subtitle: "Configurez la Comanda en ligne, la Commande à table et la Livraison.",
		},
	},
	productsWeb: {
		title: "Produits Web",
		subtitle:
			"Configurez le lien et les autres informations de la Livraison et Commande à Table.",
		saveChanges: "Enregistrer les modifications",
		toastSuccess: "Configurations enregistrées avec succès",
		availableTimeTitleDrawer: "Ajouter des jours et des horaires",
		tabs: {
			general: "Informations générales",
			entregueja: "Livraison",
			namesa: "Commande à Table",
			comanda: "Comanda en Ligne",
		},
		availableTime: {
			addRangeTime: "Ajouter un horaire",
			addDaysAndTime: "Ajouter des jours et des horaires",
			rangeTime: {
				from: "De",
				to: "À",
				startTimeLabel: "Début",
				endTimeLabel: "Fin",
			},
			daysOfTheWeekTitle: "Jours de la semaine",
			daysOfTheWeekSubtitle:
				"Sélectionnez les jours de la semaine de fonctionnement de l’établissement.",
			rangeTimeTitle: "Horaires",
			rangeTimeSubtitle:
				"Sélectionnez les horaires des jours de fonctionnement de l’établissement.",
			holidaysTitle: "Jours fériés",
			holidaysSubtitle:
				"Définissez les horaires de fonctionnement de l’établissement pendant les jours fériés.",
		},
		timeSection: {
			title: "Temps moyen",
			subtitle:
				"Définissez des informations telles que le temps moyen à afficher pour le client",
			averageAwaitTimeLabel: "Temps d’attente moyen",
			visibleInfoLabel: "Rendre visible",
			isWaitingTimeVisibleLabel: "Temps d’attente moyen",
			isOpenStatusVisibleLabel: "Statut (ouvert ou fermé)",
		},
		paymentMethodsSection: {
			title: "Moyens de paiement",
			subtitle:
				"Sélectionnez les moyens par lesquels le client pourra payer sur le site ou à la livraison de la commande.",
		},
		deliveryTaxSection: {
			title: "Frais de livraison",
			subtitle:
				"Définissez les informations relatives aux frais de livraison à afficher pour le client.",
			attendanceRadiusLabel: "Rayon de service",
			deliveryTaxTypeLabel: "Type de frais",
			deliveryFeeLabel: "Frais de livraison facturés",
			fixedDeliveryFeeLabel: "Valeur de base",
			deliveryFeePerKmLabel: "Valeur par km",
			perKmLabel: "Valeur de base",
			valueLabel: "Valeur par km",
			addMoreTax: "Ajouter un autre tarif",
			deliveryTaxType: {
				unique: "Unique",
				baseRateWithVariableKm: "Tarif de base + variable",
				ratePerRadius: "Tarif par rayon",
			},
		},
		generalTab: {
			productsLabel: "Produits Web",
			productsSubtitle: "Consultez la liste des produits web à configurer.",
			urlLabel: "Adresse URL",
			urlSubtitle:
				"Définissez l’adresse URL d’accès pour le Menu Digital, la Livraison, la Commande à Table et la Comanda en Ligne.",
			slugInvalid:
				"Le slug doit contenir uniquement des lettres, des chiffres, des tirets et des underscores",
			barLabel: "Association du bar",
			barSubtitle:
				"Définissez à quel bar seront associés les menus créés à partir de l’intégration par livraison.",
			selectBarLabel: "Sélectionnez un bar",
			selectBarTooltip:
				"Il est possible d’associer un seul bar aux menus créés à partir des intégrations",
			save: "Enregistrer les modifications",
			tagInfo: {
				entregueja: "Livraison",
				namesa: "Prépayé",
				comanda: "Postpayé",
				cardapio: "Visualisation",
			},
		},
		entregueja: {
			availableTimesSection: {
				title: "Horaires d’ouverture",
				subtitle: "Définissez les jours et horaires de fonctionnement de la Livraison",
			},
		},
		namesa: {
			availableTimesSection: {
				title: "Horaires d’ouverture",
				subtitle:
					"Définissez les jours et horaires de fonctionnement de la Commande à Table",
			},
		},
		comanda: {
			availableTimesSection: {
				title: "Horaires d’ouverture",
				subtitle:
					"Définissez les jours et horaires de fonctionnement de la Comanda en Ligne",
			},
		},
		establishmentAddress: {
			title: "Adresse de l’établissement",
			subtitle: "Informations sur l’adresse de l’établissement",
			warningTitle: "Attention",
			warningMessage:
				"Les champs d’adresse affichés sont uniquement à titre de consultation ; pour les modifier, veuillez contacter notre équipe de support.",
			postalCode: "Code postal",
			state: "État",
			city: "Ville",
			neighborhood: "Quartier",
			street: "Rue",
			number: "Numéro",
			complement: "Complément",
			complementPlaceholder: "Ex : boutique A",
		},
	},
};
